// Error codes for viewing participant operations
export enum ViewingParticipantErrorCode {
  VIEWING_NOT_FOUND = 'VIEWING_NOT_FOUND',
  VIEWING_FULL = 'VIEWING_FULL',
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  VITEC_SYNC_FAILED = 'VITEC_SYNC_FAILED',
  UPDATE_PERSON_FAILED = 'UPDATE_PERSON_FAILED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export interface ViewingParticipantError {
  code: ViewingParticipantErrorCode;
  message: string;
  details?: string;
}

// Error configuration for frontend toast messages
export const VIEWING_ERROR_CONFIG = {
  [ViewingParticipantErrorCode.VIEWING_FULL]: {
    status: 'warning' as const,
    title: 'Visningstillfället är fullbokat',
    description: 'Detta visningstillfälle är fullbokad, försök med en annan tid.'
  },
  [ViewingParticipantErrorCode.ALREADY_REGISTERED]: {
    status: 'info' as const,
    title: 'Redan anmäld',
    description: 'Du är redan anmäld till detta visningstillfälle.'
  },
  [ViewingParticipantErrorCode.VIEWING_NOT_FOUND]: {
    status: 'error' as const,
    title: 'Visningstillfället hittades inte',
    description: 'Visningstillfället kunde inte hittas.'
  },
  [ViewingParticipantErrorCode.VITEC_SYNC_FAILED]: {
    status: 'error' as const,
    title: 'Tekniskt fel',
    description: 'Ett fel uppstod vid bokning av visning. Försök igen.'
  },
  [ViewingParticipantErrorCode.UPDATE_PERSON_FAILED]: {
    status: 'error' as const,
    title: 'Kunde inte uppdatera kontaktinformation',
    description: 'Ett fel uppstod vid uppdatering av din kontaktinformation. Försök igen.'
  },
  [ViewingParticipantErrorCode.UNKNOWN_ERROR]: {
    status: 'error' as const,
    title: 'Okänt fel',
    description: 'Ett oväntat fel uppstod. Försök igen senare.'
  }
} as const;
